import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { CatalogOperator } from "../models/operator";

export const upsertCatalogOperator = async (operator: CatalogOperator) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "OperatorId", value: operator.OperatorId },
    { name: "OperatorName", value: operator.OperatorName },
    { name: "IsEAF", value: operator.IsEAF },
    { name: "IsLMF", value: operator.IsLMF },
    { name: "IsCAS", value: operator.IsCAS },
    { name: "IsBYI", value: operator.IsBYI },
    { name: "IsSY", value: operator.IsSY },
    { name: "IsForeman", value: operator.IsForeman },
    { name: "Enabled", value: operator.Enabled },
    { name: "IsActive", value: operator.IsActive },
  ];

  return await apiService.callV2("[STEEL].[UpsertOperator]", parameters);
};
export const getCatalogOperators = async (OperatorId?: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "OperatorId", value: OperatorId ?? null },
  ];

  return await apiService.callV2("[STEEL].[GetOperators]", parameters);
};

export const deleteCatalogOperator = async (OperatorId: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [];

  parameters.push({ name: "OperatorId", value: OperatorId });

  return await apiService.callV2("[STEEL].[DeleteOperator]", parameters);
};
